import React from 'react'
import NotFoundCard from 'components/NotFoundCard/NotFoundCard'
import NotAuthorizedCard from 'components/NotAuthorizedCard/NotAuthorizedCard'

export function NotFoundMock(): React.ReactElement {
  return (
    <div className="w-full scale-75 origin-top-left" style={{ width: '133%' }}>
      <NotFoundCard />
    </div>
  )
}

export function NotAuthorizedMock(): React.ReactElement {
  return (
    <div className="w-full scale-75 origin-top-left" style={{ width: '133%' }}>
      <NotAuthorizedCard />
    </div>
  )
}
